module.exports = __webpack_public_path__ + "img/patent_image16.a24edffd.png";